/**
 * The Callout component is a clickable item that is used to add to cart.
 * @param {number} index - The index of the element.
 * @param {HTMLElement} element - The element that will be bound with this class.
 */
function Callout( index, element ) {
  this.$element = $( element );
  this.index = index;

  this.id = this.$element.data( "product-id" );

  this.selectors = {
    button: ".callout__button",
    card: ".callout__inner",
    subscription: ".callout__subscription",
    subscriptionOption: ".callout-subscription__option input",
    subscriptionAdd: ".callout-subscription__add",
    subscriptionSkip: ".callout-subscription__cancel"
  }

  this.initialize();
}

Callout.prototype = Object.assign( {}, Callout.prototype, {
  initialize: function() {
    // Get child elements.
    this.$button = this.$element.find( this.selectors.button );
    this.$card = this.$element.find( this.selectors.card );
    this.$subscription = this.$element.find( this.selectors.subscription );
    this.$subscriptionOptions = this.$element.find( this.selectors.subscriptionOption );
    this.$subscriptionAdd = this.$element.find( this.selectors.subscriptionAdd );
    this.$subscriptionSkip = this.$element.find( this.selectors.subscriptionSkip );

    // Add event listeners.
    this.$button.on( "click", this._handleButtonClick.bind( this ) );
    this.$subscriptionAdd.on( "click", this._handleSubscriptionAddClick.bind( this ) );
    this.$subscriptionSkip.on( "click", this._handleSkipClick.bind( this ) );
    this.$element.on( "cart:added", this._handleSuccesfulAddToCart.bind( this ) );
  },

  _getProductProps: function() {
    const _bg_color = this.$element.data( "background-color" );
    const _text_color = this.$element.data( "text-color" );
    const _compare_at_price = this.$element.data( "compare-price" );
    const _Product_title = this.$element.data( "product-title" );
    const _hasStraws = this.$element.data( "straws" );
    const _overimage = this.$element.data( "image-over" );
    const _case_title = this.$element.data( "case-title" );
    const _hasUpTag = this.$element.data( "up-tag" );
    var _return = false;    
    
    if (this.$element.data( "up-tag" ) != null && this.$element.data( "straws" ) == null ){
      _return = true;
      return { _bg_color, _text_color, _compare_at_price, _Product_title, _hasUpTag };
    }
    if ( this.$element.data( "straws" ) != null ){
      _return = true;
      return { _bg_color, _text_color, _compare_at_price, _Product_title, _hasStraws };
    }
    if( this.$element.data( "image-over" ) != null || this.$element.data( "case-title" ) != null  ){
      _return = true;
      return { _bg_color, _text_color, _compare_at_price, _Product_title, _overimage, _case_title };      
    }
    if( !_return ) return { _bg_color, _text_color, _compare_at_price, _Product_title };
  },

  _createCartEvent: function() {
    // Create a one-time event listener that will trigger "cart:added" event on this element.
    $( document ).one( "cart.requestComplete", function() {
      this.$element.trigger( "cart:added" );
    }.bind( this ) );
  },

  _addToCart: function( id, sellingPlan ) {
    // Check if CartJS has been initialized.    
    if( CartJS ) {
      let properties = this._getProductProps();

      if( sellingPlan ) {
        properties = Object.assign( {}, properties, {
          selling_plan: sellingPlan
        } );
      }

      // Add product with ID to cart and handle the events.
      CartJS.addItem( id, 1, properties );

      this._createCartEvent();
    }
  },

  _handleSuccesfulAddToCart: function() {
    console.log( "Item has been successfully added to the cart." );
  },

  _shouldShowSubscriptions: function( event ) {
    // Only show subscriptions if the cart has one item.
    if( CartJS && CartJS.cart.items.length == 1 ) {
      const item = CartJS.cart.items[ 0 ];
      // Then, check if the only cart item has a subscription plan.
      if( item.selling_plan_allocation ) return true;
    }

    return false;
  },

  _showSubscription: function( state ) {
    this.$card.toggle( !state );
    this.$subscription.toggle( state );
  },

  _handleButtonClick: function( event ) {
    if( this._shouldShowSubscriptions() ) {
      this._showSubscription( true );
    } else {
      this._addToCart( this.id );
    }
  },

  _handleSubscriptionAddClick: function( event ) {
    const $selectedOption = this.$subscriptionOptions.filter( ":checked" );
    const planID = $selectedOption.val();

    this._addToCart( this.id, planID );

    // Hide the subscription after item has been added to the cart.
    this.$element.one( "cart:added", function() {
      this._showSubscription( false );
    }.bind( this ) );
  },

  _handleSkipClick: function( event ) {
    this._addToCart( this.id );

    // Hide the subscription after item has been added to the cart.
    this.$element.one( "cart:added", function() {
      this._showSubscription( false );
    }.bind( this ) );
  }
});

// Initialize all .callout items with the Callout class.
$( ".callout" ).each( function( index, element ) {
  // Do something with the created callout.
  const callout = new Callout( index, element );
} );



/**
 * Cart component that adds class hooks depending on the state of the cart.
 * @param {number} index - The index of the element.
 * @param {HTMLElement} element - The element that will be bound with this class.
 */
function Cart( index, element ) {
  this.$element = $( element );
  this.index = index;

  this.selectors = {
    cartItems: ".cart-items"
  }

  this.states = {
    cartItems: {
      IS_REQUESTING: "cart-items--is-requesting"
    }
  }

  this.initialize();
}

Cart.prototype = Object.assign( {}, Cart.prototype, {
  initialize: function() {
    this.$cartItems = this.$element.find( this.selectors.cartItems );

    // Listen to the cart events.
    $( document ).on( "cart.requestStarted", this._handleCartRequestStart.bind( this ) );
    $( document ).on( "cart.requestComplete", this._handleCartRequestComplete.bind( this ) );
  },

  _handleCartRequestStart: function() {
    this.$cartItems.addClass( this.states.cartItems.IS_REQUESTING );
  },

  _handleCartRequestComplete: function() {
    this.$cartItems.removeClass( this.states.cartItems.IS_REQUESTING );
  }
} );

// Initialize all .cart__form items with the Cart class.
$( ".cart__form" ).each( function( index, element ) {
  // Do something with the created cart.
  const cart = new Cart( index, element );
} );